import Fade from '@mui/material/Fade';

// Material Home 2 React base styles
import colors from '@assets/theme/base/colors';
import borders from '@assets/theme/base/borders';

// Material Home 2 React helper functions
import pxToRem from '@assets/theme/functions/pxToRem';

const { black, white } = colors;
const { borderRadius } = borders;

const tooltip = {
    defaultProps: {
        arrow: true,
        TransitionComponent: Fade
    },

    styleOverrides: {
        tooltip: {
            maxWidth: pxToRem(220),
            backgroundColor: black.main,
            color: white.main,
            fontSize: '1rem',
            fontWeight: 500,
            textAlign: 'center',
            borderRadius: borderRadius.md,
            opacity: 1,
            padding: `${pxToRem(9)} ${pxToRem(14)}`
        },

        arrow: {
            color: black.main
        }
    }
};

export default tooltip;
